/* ThaBel — coleção: filtros sem recarregar a página (paginação tradicional) */
(() => {
  if (customElements.get('tb-colecao')) return;

  class TbColecao extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => this.aoClicar(e));
      this.addEventListener('change', (e) => this.aoMudar(e));
      this.addEventListener('submit', (e) => { e.preventDefault(); this.aplicarForm(); });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-filtros-celular')) this.fecharCelular();
      });
      window.addEventListener('popstate', () => this.buscar(window.location.href, { historico: false }));

      this.preparar();
    }

    celular() { return window.matchMedia('(max-width: 989px)').matches; }

    preparar() {
      this.atualizarTextoFiltros();
    }

    /* ---------- abrir / fechar filtros ---------- */
    aoClicar(e) {
      if (e.target.closest('[data-tb-toggle-filtros]')) {
        if (this.celular()) {
          this.classList.add('is-filtros-celular');
          document.documentElement.classList.add('tb-sem-rolagem');
          this.gatilho = e.target.closest('button');
          requestAnimationFrame(() => this.querySelector('.tb-filtros__fechar')?.focus());
        } else {
          this.classList.toggle('is-filtros');
          this.atualizarTextoFiltros();
        }
        return;
      }
      if (e.target.closest('[data-tb-fechar-filtros]')) { this.fecharCelular(); return; }

      const link = e.target.closest('a[data-tb-link]');
      if (link) { e.preventDefault(); this.buscar(link.href); }
    }

    fecharCelular() {
      if (!this.classList.contains('is-filtros-celular')) return;
      this.classList.remove('is-filtros-celular');
      document.documentElement.classList.remove('tb-sem-rolagem');
      (this.gatilho || this.querySelector('[data-tb-toggle-filtros]'))?.focus();
    }

    atualizarTextoFiltros() {
      const t = this.querySelector('[data-tb-txt-filtros]');
      if (t) t.textContent = this.classList.contains('is-filtros') ? t.dataset.txtFechar : t.dataset.txtAbrir;
      const b = this.querySelector('[data-tb-toggle-filtros]');
      if (b) b.setAttribute('aria-expanded', this.classList.contains('is-filtros') ? 'true' : 'false');
    }

    /* ---------- filtros e ordenação ---------- */
    aoMudar(e) {
      if (!e.target.closest('[data-tb-filtros]')) return;
      clearTimeout(this.espera);
      const atraso = e.target.type === 'number' ? 600 : 250;
      this.espera = setTimeout(() => this.aplicarForm(), atraso);
    }

    aplicarForm() {
      const form = this.querySelector('[data-tb-filtros]');
      if (!form) return;
      const params = new URLSearchParams();
      new FormData(form).forEach((valor, chave) => { if (String(valor).trim() !== '') params.append(chave, valor); });
      const q = params.toString();
      this.buscar(`${window.location.pathname}${q ? `?${q}` : ''}`);
    }

    urlSecao(url) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.dataset.section);
      return u.toString();
    }

    async buscar(url, { historico = true } = {}) {
      const ativo = document.activeElement;
      const focoId = ativo && this.contains(ativo) ? ativo.id : null;
      this.classList.add('is-carregando');
      try {
        const html = await fetch(this.urlSecao(url)).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const novo = doc.querySelector('[data-tb-alvo]');
        const alvo = this.querySelector('[data-tb-alvo]');
        if (!novo || !alvo) { window.location.href = url; return; }
        // mantém abertos os grupos de filtro que o cliente abriu
        const abertos = [...this.querySelectorAll('.tb-filtro')].map((d) => d.open);
        alvo.innerHTML = novo.innerHTML;
        this.querySelectorAll('.tb-filtro').forEach((d, i) => { if (abertos[i] !== undefined) d.open = abertos[i] || d.open; });
        if (historico) {
          const u = new URL(url, window.location.origin);
          u.searchParams.delete('section_id');
          u.searchParams.delete('page');
          window.history.pushState({}, '', u.toString());
        }
        this.preparar();
        if (focoId) document.getElementById(focoId)?.focus();
        const total = this.querySelector('[data-tb-total]');
        if (total) this.anunciar(total.textContent.trim());
      } catch (erro) {
        window.location.href = url;
      } finally {
        this.classList.remove('is-carregando');
      }
    }

    anunciar(texto) {
      const el = this.querySelector('[data-tb-anuncio]');
      if (el) { el.textContent = ''; setTimeout(() => { el.textContent = texto; }, 50); }
    }
  }
  customElements.define('tb-colecao', TbColecao);

  // "Ler mais" do texto de SEO
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tb-ler-mais]');
    if (!b) return;
    const alvo = document.getElementById(b.getAttribute('aria-controls'));
    if (!alvo) return;
    const aberto = alvo.classList.toggle('is-aberto');
    b.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    b.textContent = aberto ? 'Ler menos' : 'Ler mais';
  });
})();
